import { createReducer, on } from '@ngrx/store';
import { Company } from '@models/company.model';
import {
  cannotCreateCompany,
  cannotDeleteCompany,
  cannotFetchCompanies,
  cannotUpdateCompany,
  companiesFetched,
  companyCreated,
  companyDeleted,
  companyUpdated,
  createCompany,
  deleteCompany,
  fetchCompanies,
  selectCompany,
  updateCompany
} from '../actions/company.actions';
import { SharedState } from './index';

export interface CompanyState extends SharedState {
  companies: Company[];
  selectedCompanyId: string | null;
}

export const initialCompanyState: CompanyState = {
  loaded: false,
  isLoading: false,
  error: '',
  companies: [],
  selectedCompanyId: null,
}

export const companyReducer = createReducer(
  initialCompanyState,
  on(fetchCompanies, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(companiesFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    companies: payload,
    selectedCompanyId: payload.length === 1 ? payload[0].id : state.selectedCompanyId
  })),
  on(cannotFetchCompanies, (state, {error}) => ({...state, isLoading: false, loaded: false, error, companies: []})),
  on(updateCompany, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(companyUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    companies: state.companies.map(c => c.id === payload.id ? payload : c)
  })),
  on(cannotUpdateCompany, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(createCompany, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(companyCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    companies: [...state.companies, payload]
  })),
  on(cannotCreateCompany, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(deleteCompany, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(companyDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    companies: state.companies.filter(company => company.id !== payload)
  })),
  on(cannotDeleteCompany, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(selectCompany, (state, {payload}) => ({...state, selectedCompanyId: payload})),
);
